import React from "react";
import { AbsoluteFill, Sequence } from "remotion";
import { UraniumSeg1 } from "./UraniumSeg1";
import { UraniumSeg23 } from "./UraniumSeg23";
import { UraniumSeg4plus } from "./UraniumSeg4plus";

// Full 713.713s production timeline, three layers — all on the same audio timeline:
//   • Part 1  (UraniumSeg1)    — sliding "10g uranium = coal/oil/gas/6wks" comparison chain.
//     Its constant uranium tag never self-fades, so it's CLAMPED to its 0–14.59s window
//     (234 frames) via a Sequence so it can't bleed into Part 2.
//   • Parts 2–3 (UraniumSeg23) — universal lower-left UTags, 15–40s; each tag self-fades
//     via win(), so no clamp needed.
//   • Parts 4–54 (UraniumSeg4plus) — universal lower-left UTags, 64–713s; self-fading.
// One tag visible at a time across the whole video → single lower-left slot, no z-fight.
export const UraniumFull: React.FC = () => (
  <AbsoluteFill>
    <Sequence from={0} durationInFrames={234} layout="none">
      <UraniumSeg1 />
    </Sequence>
    <UraniumSeg23 />
    <UraniumSeg4plus />
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
